<i class="{{ getBatteryClass() }} align-middle" title="{{ getText() }}"></i>
&nbsp;
<span *ngIf="showValue">{{ getText() }}</span>
